import StateControllerBase from "@/store/stateControllerBase";
import { setLoadingState } from "@/store/setLoadingState";

import DepositController from "@/api/depositController";

const depositController = new DepositController();

class Actions extends StateControllerBase {
  setDataLoading({ commit }, dataLoading) {
    commit("setDataLoading", dataLoading);
  }

  @setLoadingState
  async depositWithBankCard(_context, params) {
    return await depositController.depositWithBankCard(params);
  }
}
export default (new Actions).asPlainObject();
